import { slider } from "./components/slider";
import { topicsSlider } from "./components/slider";

$(document).ready(function () {
  $(".p-hamburger-btn").on("click", function () {
    $(this).children(".is-deco").toggleClass("is-active");
    $(this).children(".is-text").toggleClass("is-active");
    $(".p-hamburger-menu").toggleClass("is-active");
    $("body").toggleClass("is-active");
  });

  (() => {
    /*
    スライダー用関数
    */
    const sliderEl = ".l-first-view__swiper";
    slider(sliderEl);

    const topicsEl = ".l-front-topics__slide-content__swiper";
    topicsSlider(topicsEl);
  })();

  if (!navigator.userAgent.match(/(iPhone|iPad|iPod|Android)/)) {
    $('.is-tell-link').addClass('is-nonelink');
  }

});